// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2nzuK","title":"BackImages_title__11MPy","images":"BackImages_images__2yM7n"};